import { Box, Chip } from "@mui/material";
import { FC } from "react";
import { EventProps } from "react-big-calendar";
import Flex from "../../../../../../components/Flex";
import Text from "../../../../../../components/Text";
import { TaskTaskStatusEnum } from "../../../../../../services";
import { formatTime } from "../../../../../../utils/date-time-utility";
import {
  getValueFromObj,
  replaceUnderScoreAddSpace,
} from "../../../../../../utils/utils";
import { ViewType } from "../../../scheduling/SchedulingLayout";
import { ACTIVITY_MAPPING } from "../../collaboration-task-constant";

function taskCalendarEvent(
  props: EventProps,
  view?: ViewType,
  onActionClick?: (v: any) => void
  // onEdit?: (v: any) => void
) {
  const { taskStatus, start, title, priority, actions } = props.event as any;

  const action = getValueFromObj(actions);

  const startDate = formatTime(start, {
    withSeconds: true,
  });
  // const endDate = formatTime(dueDate, {
  //   withoutSeconds: true,
  // });

  const activeStatusColor = TASK_STATUS_COLOR[taskStatus as TaskTaskStatusEnum];

  const Date = () => (
    <Flex
      gap={1}
      justifyContent={"space-between"}
      width={"100%"}
      height={"20px"}
    >
      <Text fontSize={"12px"}>{`${startDate} `}</Text>

      <Chip
        size="small"
        style={{ backgroundColor: "#EEF7FD", color: "#0097F0" }}
        label={
          <Text fontSize={"12px"}>
            {replaceUnderScoreAddSpace(priority?.toLowerCase())}
          </Text>
        }
      />
    </Flex>
  );

  return (
    <Flex
      maxHeight={"auto"}
      borderRadius={1}
      bgcolor={"#F3F4F6"}
      id="comp"
      mb={0.2}
      mr={view === "day" ? 1.5 : 0}
      // onClick={() => onEdit?.(props?.event)}
    >
      <Box minWidth={"4px"} borderRadius={10} bgcolor={activeStatusColor} />

      <Flex
        gap={view !== "month" ? 0 : 0.4}
        ml={1}
        justifyContent={view !== "month" ? "center" : "normal"}
        width={"100%"}
      >
        <Flex gap={0} flexDirection={"column"} width={"100%"}>
          <Flex justifyContent={"space-between"}>
            <Text textOverflow={"ellipsis"}>{title}</Text>
            <ActionButton
              action={action ?? "Other"}
              onclick={() => onActionClick?.(props?.event)}
            />
          </Flex>
          <Date />
          <Text fontSize={"10px"} textOverflow={"ellipsis"}>
            {getValueFromObj((props?.event as any)?.assignTo)}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default taskCalendarEvent;

const TASK_STATUS_COLOR: Record<TaskTaskStatusEnum, string> = {
  RESOLVED: "#049B22",
  TO_DO: "#004AB1",
  OVERDUE: "#943C00",
};

const ActionButton: FC<{ action: string; onclick: () => void }> = ({
  action,
  onclick,
}) => {
  const activityConfig =
    ACTIVITY_MAPPING[action as keyof typeof ACTIVITY_MAPPING] ||
    ACTIVITY_MAPPING.Visit;

  if (!activityConfig.icon) return null;

  const Icon = activityConfig.icon;
  return (
    <Icon
      onClick={(e) => {
        e.stopPropagation();
        onclick();
      }}
      fontSize="small"
      sx={{
        color: activityConfig.color,
        minWidth: "3px !important",
        cursor: "pointer",
      }}
    />
  );
};
